import styled, { css } from 'styled-components';
export const MenuWrapper = styled.div `
  ${({ theme }) => theme.shadows.Default}
  background-color: ${({ theme }) => theme.colors.White};
  display: flex;
  flex-direction: column;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  border-radius: 5px;
  position: absolute;
  z-index: 1000;
`;
export const MenuItemWrapper = styled.div `
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  cursor: pointer;
  display: flex;
  transition: all 100ms linear;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey4};
  padding: 12px 33px;
  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.Grey1};
    color: ${({ theme }) => theme.colors.PrimaryHover};
  }
  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.colors.Grey2};
    color: ${({ theme }) => theme.colors.PrimaryHover};
  }
  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey3};
      color: ${({ theme }) => theme.colors.TextDisabled};
      pointer-events: none;
    `};
`;
//# sourceMappingURL=BKJMenu.styled.js.map